import type {
  CurationCellStatus,
  CurationVerificationStatus,
  ExtractionCell,
  ExtractionClaim,
} from "@/features/data-curation/types";

// The verifier does not check a claim whose cited source has no text lines.
export const hasNoTextLines = (claim: ExtractionClaim) =>
  claim.latest_verdict_payload.no_text_lines === true;

export const claimStatus = (
  claim: ExtractionClaim,
): CurationVerificationStatus => {
  if (claim.supported === true) return "verified";
  if (claim.supported === false) return "rejected";
  if (hasNoTextLines(claim)) return "explained";
  return "pending";
};

export const cellStatus = (cell: ExtractionCell): CurationCellStatus => {
  if (cell.support_type === "explanation") {
    return cell.record_match ? "matched" : "explained";
  }
  const statuses = cell.claims.map(claimStatus);
  if (statuses.includes("rejected")) return "rejected";
  if (statuses.length > 0 && statuses.every((status) => status === "verified")) {
    return "verified";
  }
  if (
    statuses.length > 0 &&
    statuses.every((status) => status === "verified" || status === "explained")
  ) {
    return "explained";
  }
  return "pending";
};
